import { useRef, useState } from 'react';

import {
  Box,
  Button,
  Menu,
  MenuItem
} from '@mui/material';
import React from 'react';
import { useDashboards } from '../../../../contexts/DashboardContext';
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import { Dashboard } from '../../../../DashboardApi/api';

function DashboardSwitcher() {
  const { dashboards, defaultDashboard, currentDashboard, changeDashboard } = useDashboards();
  const [openPeriod, setOpenMenuPeriod] = useState<boolean>(false);
  const actionRef1 = useRef<any>(null);
  
  return (
    <>
    {
      dashboards.length > 1 ? (
        <Box
        sx={{
          flexGrow: { xs: 1, md: 0 },
        }}
      >
          <Button
            size="small"
            color="info"
            variant="contained"
            sx={{
              mt: { xs: 2, sm: 0 },
            }}
            ref={actionRef1}
            onClick={() => setOpenMenuPeriod(true)}
            endIcon={<ExpandMoreTwoToneIcon fontSize="small" />}
          >
            {currentDashboard?.name}
          </Button>
          <Menu
            disableScrollLock
            anchorEl={actionRef1.current}
            onClose={() => setOpenMenuPeriod(false)}
            open={openPeriod}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {dashboards
              .filter((item) => item.tag != currentDashboard?.tag)
              .map((dash) => (
                <MenuItem
                sx={{
                  fontWeight:"bold",
                  color:`HighlightText`
                }}
                  key={dash.id}
                  onClick={() => {
                    changeDashboard(dash);
                    setOpenMenuPeriod(false);
                  }}
                >
                  {dash.name}
                </MenuItem>
              ))}
          </Menu>
      </Box>
      ) : null
    }
    </>
  );
}

export default DashboardSwitcher;
